exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form{container-type:inline-size}.style-cssmodule-inputGrid-1JXeA{--gap:25px;display:grid;grid-template-columns:repeat(2,calc(50% - var(--gap) / 2));column-gap:var(--gap);row-gap:var(--gap);margin-bottom:30px}@container (max-width:420px){.style-cssmodule-inputGrid-1JXeA{grid-template-columns:repeat(1,1fr)}}.style-cssmodule-title-1lhja{color:var(--color-blue-middle,#1147b7);font-family:Roboto;font-size:40px;font-style:normal;font-weight:500;line-height:40px;letter-spacing:.4px}.style-cssmodule-subtitle-2JkGn{color:var(--color-sky-gray6,#8793a6);font-family:Roboto;font-size:18px;font-style:italic;font-weight:400;line-height:22px}.style-cssmodule-signUpButton-TSDYP{font-weight:700;display:flex;align-items:center;justify-content:center;column-gap:12px;fill:var(--color-white,#fff)}.style-cssmodule-successMessage-3MsSz{color:var(--color-sky-gray7,#79879b);font-family:Roboto;font-size:14px;font-style:normal;font-weight:400;line-height:28px}.style-cssmodule-messageTopRight-32VNq{position:fixed;top:30px;right:20px;max-width:90vw}", ""]);

// exports
exports.locals = {
	"inputGrid": "style-cssmodule-inputGrid-1JXeA",
	"title": "style-cssmodule-title-1lhja",
	"subtitle": "style-cssmodule-subtitle-2JkGn",
	"signUpButton": "style-cssmodule-signUpButton-TSDYP",
	"successMessage": "style-cssmodule-successMessage-3MsSz",
	"messageTopRight": "style-cssmodule-messageTopRight-32VNq"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/login/components/cpm_client/components/SignUp/style.cssmodule.css
// module id = 2570
// module chunks = 121